import { useMemo } from 'react'
import type { WeeklyPlanVsFactRow } from '@/hooks/useWeeklyPlanVsFact'
import type { PlanData } from '@/hooks/useStudioAnalytics'
import { hasAnyPlanValues } from '@/lib/weeklyPlan'

interface UseStudioPlanDiagnosticsParams {
  weeklyPlanVsFactWeeks: WeeklyPlanVsFactRow[]
  planData: PlanData | null
  studioNumber: string
  totalRevenue: number
}

export function useStudioPlanDiagnostics({
  weeklyPlanVsFactWeeks,
  planData,
  studioNumber,
  totalRevenue
}: UseStudioPlanDiagnosticsParams) {
  return useMemo(() => {
    const hasWeeklyPlanForStudio = weeklyPlanVsFactWeeks.some(hasAnyPlanValues)
    const hasAnyPlanForStudio = hasWeeklyPlanForStudio || planData !== null
    const missingPlanStudios = hasAnyPlanForStudio ? [] : [studioNumber]
    const zeroRevenueStudios = totalRevenue === 0 ? [studioNumber] : []
    const isStudioPlanRevenueZero = hasAnyPlanForStudio && (planData?.total_gross_revenue_plan || 0) === 0
    const zeroPlanRevenueStudios = isStudioPlanRevenueZero ? [studioNumber] : []
    const shouldHideDelta = isStudioPlanRevenueZero || !hasAnyPlanForStudio

    return {
      hasAnyPlanForStudio,
      missingPlanStudios,
      zeroRevenueStudios,
      zeroPlanRevenueStudios,
      shouldHideDelta
    }
  }, [weeklyPlanVsFactWeeks, planData, studioNumber, totalRevenue])
}
